import { Link, createFileRoute } from '@tanstack/react-router'
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Separator } from "@/components/ui/separator"
import { useForm } from "react-hook-form"
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
  } from "@/components/ui/form"
import { useMutation } from "@tanstack/react-query"
import { addNumberToPhoneBook } from "@/queries/phonebook"
import { toast } from "sonner"
import z from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'

export const Route = createFileRoute('/phone-book/create/')({
  component: CreatePhoneBook,
})


function CreatePhoneBook() {
  const navigate = Route.useNavigate()

  const createSchema = z.object({
    phone_number: z.string({required_error:'وارد کردن شماره تلفن الزامی است' }),
    name: z.string({required_error: 'وارد کردن نام الزامی می باشد'}).min(3, 'نام کاربر نمی تواند کمتر از ۳ حرف باشد')
  })

  const form = useForm<z.infer<typeof createSchema>>({
    resolver: zodResolver(createSchema),
    values: {
      phone_number: '',
      name: '',
    }
  })

  const createPhoneBookMutation = useMutation({
    mutationFn: (data: z.infer<typeof createSchema>) => addNumberToPhoneBook(data.name, data.phone_number, {}),
    mutationKey: ['create', 'phoneBook'],
    onSuccess() {
      // console.log('phone book created!')
      toast.success('مخاطب با موفقیت اضافه شد')
      navigate({to: '/phone-book'})
    },
    onError(e: any) {
      if (e?.response?.data?.message) {
        if (e.response.data.message.includes('already')) {
          toast.error('شماره تلفن وارد شده تکراری می باشد')
        }
      } else {
        toast.error('خطایی در ایجاد مخاطب رخ داده است')
      }
      // console.log('phone book error !')
    }
  })

  const onSubmit = (values: z.infer<typeof createSchema>) => {
    createPhoneBookMutation.mutate(values)
  }

  return <>
    <Card>
      <CardHeader className="flex flex-row justify-between items-center">
        <CardTitle>
          ایجاد مخاطب
        </CardTitle>
        <Link to="/phone-book">
          <Button variant="outline">
            بازگشت
          </Button>
        </Link>
      </CardHeader>
      <Separator className="my-2" />
      <CardContent>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <FormField control={form.control} name="phone_number" render={({ field }) => <FormItem>
              <FormLabel>شماره تلفن</FormLabel>
              <FormControl>
                <Input {...field} phone maxLength={11} type="tel" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

            <FormField control={form.control} name="name" render={({ field }) => <FormItem className="my-2">
              <FormLabel>
                نام مخاطب
              </FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

            <Button className="mt-4" isLoading={createPhoneBookMutation.isPending}>ذخیره</Button>
          </form>
        </Form>
      </CardContent>
    </Card>
  </>
}
